import * as React from 'react';

interface UICoreRangeSliderProps {
    min: number;
    max: number;
    label: string;
    initialValue: number;
    areaTolerance?: number;
    onChange?: (value: number) => void;
}

interface UICoreRangeSliderState {
    value: number;
}

export class UICoreRangeSlider extends React.Component<UICoreRangeSliderProps, UICoreRangeSliderState> {
    get value(): number {
        if (this.state == null) {
            return 0;
        }
        return this.state.value;
    }
    set value(value: number) { this.setState({value: value}); }

    protected container: HTMLDivElement;
    protected actionArea: HTMLDivElement;

    public setValue = (value: number, call: boolean): void => {
        if (this.value !== value) {
            this.value = value;
            if (call && this.props.onChange != null) {
                this.props.onChange(value);
            }
        }
    };

    public componentWillMount(): void {
        if (this.props.initialValue != null) {
            this.setValue(this.props.initialValue, false);
        } else {
            this.setValue(this.props.min, false);
        }
    }

    public componentDidMount(): void {
        this.bindEvents();
    }

    public componentWillUnmount(): void {
        this.unbindEvents();
    }

    public render(): JSX.Element {
        return (
            <div className="ui-core-range-slider-container" ref={(node: HTMLDivElement) => { this.container = node; }}>
                {this.props.label != null ? <div className="ui-core-range-slider-label">{this.props.label + ' ' + this.leftPos()}</div> : null}
                <div className="ui-core-range-slider">
                    <div
                        className="ui-core-range-slider-area"
                        style={{
                            left: this.props.areaTolerance == null ? 0 : -this.props.areaTolerance,
                            right: this.props.areaTolerance == null ? 0 : -this.props.areaTolerance
                        }}
                        ref={(node: HTMLDivElement) => { this.actionArea = node; }}
                    />
                    <div style={{left: this.leftPos()}} className="ui-core-range-slider-thumb"/>
                    <div style={{width: this.leftPos()}} className="ui-core-range-slider-leftbar"/>
                    <div style={{left: this.leftPos()}} className="ui-core-range-slider-rightbar"/>
                </div>
            </div>
        );
    }

    protected pointerEvent = (pointerEvent: PointerEvent): void => {
        if (pointerEvent.buttons === 1) {
            const rect: ClientRect = this.actionArea.getBoundingClientRect();
            const pixelPos: number = pointerEvent.pageX - rect.left;
            const percentPos: number = Math.min(
                Math.max(
                    (
                        (pixelPos - (this.props.areaTolerance == null ? 0 : this.props.areaTolerance)) /
                        (rect.width - 2 * (this.props.areaTolerance == null ? 0 : this.props.areaTolerance))
                    ),
                    0
                ),
                1
            );
            this.setValue((this.props.max - this.props.min) * percentPos, true);
        }
    };

    protected bindEvents = (): void => {
        this.container.setAttribute('touch-action', 'none');
        this.actionArea.addEventListener('pointermove', this.pointerEvent, true);
        this.actionArea.addEventListener('pointerdown', this.pointerEvent, true);
    };

    protected unbindEvents = (): void => {
        this.actionArea.removeEventListener('pointermove', this.pointerEvent, true);
        this.actionArea.removeEventListener('pointerdown', this.pointerEvent, true);
    };

    protected leftPos = (): string => {
        return Math.round(
            100 * (this.value - this.props.min) /
            (this.props.max - this.props.min)
        ) + '%';
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/UICoreRangeSlider.tsx